//
// This file is auto generated. See ./README.md for details
//
import React from 'react'
import { Icon as ChakraIcon } from '@chakra-ui/react'
import {
  HubResponsiveValue,
  StandardIconSizes,
  HubStyleObject,
  forwardRef,
  IconColors,
} from '@hub/design-system-base'
import { default as ClearInvertedSmallSVG } from './assets/small/clear-inverted.inline.svg'

interface ClearInvertedSmallIconProps {
  boxSize?: HubResponsiveValue<StandardIconSizes>
  sx?: HubStyleObject
  ariaLabel?: string
  color?: IconColors
}

export const ClearInvertedSmallIcon: React.FC<
  React.PropsWithChildren<ClearInvertedSmallIconProps>
> = forwardRef<ClearInvertedSmallIconProps, typeof ChakraIcon>(
  ({ boxSize = 'size-icon-sm', sx, ariaLabel, color }, ref) => (
    <ChakraIcon
      ref={ref}
      boxSize={boxSize}
      aria-label={ariaLabel}
      as={ClearInvertedSmallSVG}
      sx={sx}
      color={color}
    />
  )
)
